import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-srm-details-skeleton',
  imports: [
    NgxSkeletonLoaderModule,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './srm-details-skeleton.component.html',
})
export class SrmDetailsSkeletonComponent {
}
